// import React from "react";

// /**
//  * Two floating cards that sit on top of the hero photo:
//  * 1. TodaysCollectionCard  – dark stat panel, top-right
//  * 2. DashboardPreviewCard  – white metrics + charts card, bottom
//  *
//  * Usage:
//  * <div className="tw-hero-photo" style={{ backgroundImage: "url(...)" }}>
//  *   <TodaysCollectionCard />
//  *   <DashboardPreviewCard />
//  * </div>
//  *
//  * The parent (.tw-hero-photo) needs position: relative for the
//  * absolute positioning below to work.
//  */

// export function TodaysCollectionCard() {
//   return (
//     <div className="tw-stat-card">
//       <div className="tw-stat-card__row">
//         <span className="tw-stat-card__label">Today's Collection</span>
//       </div>
//       <div className="tw-stat-card__value">
//         12,650<span className="tw-stat-card__unit">Ltrs</span>
//       </div>
//       <div className="tw-stat-card__delta">↑ 12.5% vs yesterday</div>

//       <div className="tw-stat-card__divider" />

//       <div className="tw-stat-card__row">
//         <span className="tw-stat-card__label">Active Farmers</span>
//       </div>
//       <div className="tw-stat-card__value tw-stat-card__value--sm">2,458</div>
//       <div className="tw-stat-card__delta">↑ 6.4% this month</div>

//       <div className="tw-stat-card__divider" />

//       <div className="tw-stat-card__row">
//         <span className="tw-stat-card__label">Collection Centres</span>
//       </div>
//       <div className="tw-stat-card__value tw-stat-card__value--sm">32</div>
//       <div className="tw-stat-card__delta tw-stat-card__delta--neutral">
//         All centres active
//       </div>
//     </div>
//   );
// }

// export function DashboardPreviewCard() {
//   const metrics = [
//     { label: "Total Farmers", value: "2,458", change: "↑ 12% this month" },
//     { label: "Milk Collection (L)", value: "125,680", change: "↑ 15.3% this month" },
//     { label: "Coffee Collection (Kg)", value: "48,420", change: "↑ 10.6% this month" },
//     { label: "Active Centres", value: "32", change: "↑ 3 this month" },
//   ];

//   // Simple trend line points (purely decorative, swap for real data)
//   const trendPoints = "0,40 20,32 40,36 60,20 80,28 100,10 120,18 140,4";

//   const donutSegments = [
//     { name: "Kangema", value: 35, color: "#F97316" },
//     { name: "Kihuu", value: 25, color: "#22C55E" },
//     { name: "Muranga", value: 22, color: "#3B82F6" },
//     { name: "Maragua", value: 18, color: "#EAB308" },
//   ];

//   return (
//     <div className="tw-dashboard-card">
//       <div className="tw-dashboard-card__header">Dashboard</div>

//       <div className="tw-dashboard-card__metrics">
//         {metrics.map((m) => (
//           <div className="tw-dashboard-card__metric" key={m.label}>
//             <div className="tw-dashboard-card__metric-label">{m.label}</div>
//             <div className="tw-dashboard-card__metric-value">{m.value}</div>
//             <div className="tw-dashboard-card__metric-change">{m.change}</div>
//           </div>
//         ))}
//       </div>

//       <div className="tw-dashboard-card__charts">
//         <div className="tw-dashboard-card__chart-block">
//           <div className="tw-dashboard-card__chart-title">
//             Milk Collection Trend (Litres)
//           </div>
//           <svg viewBox="0 0 140 44" className="tw-dashboard-card__trend">
//             <polyline
//               points={trendPoints}
//               fill="none"
//               stroke="#22C55E"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//           </svg>
//           <div className="tw-dashboard-card__chart-xaxis">
//             <span>07 May</span>
//             <span>15 May</span>
//             <span>22 May</span>
//             <span>31 May</span>
//           </div>
//         </div>

//         <div className="tw-dashboard-card__chart-block tw-dashboard-card__chart-block--donut">
//           <div className="tw-dashboard-card__chart-title">
//             Collection by Centre
//           </div>
//           <div className="tw-dashboard-card__donut-row">
//             <DonutChart segments={donutSegments} />
//             <ul className="tw-dashboard-card__legend">
//               {donutSegments.map((s) => (
//                 <li key={s.name}>
//                   <span
//                     className="tw-dashboard-card__legend-dot"
//                     style={{ backgroundColor: s.color }}
//                   />
//                   {s.name} {s.value}%
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function DonutChart({ segments }) {
//   const radius = 16;
//   const circumference = 2 * Math.PI * radius;
//   let offsetAccum = 0;

//   return (
//     <svg width="56" height="56" viewBox="0 0 40 40">
//       {segments.map((s) => {
//         const dash = (s.value / 100) * circumference;
//         const el = (
//           <circle
//             key={s.name}
//             cx="20"
//             cy="20"
//             r={radius}
//             fill="none"
//             stroke={s.color}
//             strokeWidth="6"
//             strokeDasharray={`${dash} ${circumference - dash}`}
//             strokeDashoffset={-offsetAccum}
//             transform="rotate(-90 20 20)"
//           />
//         );
//         offsetAccum += dash;
//         return el;
//       })}
//     </svg>
//   );
// }


import React from "react";

/**
 * IMPORTANT: HeroStats / HeroDashboard must be siblings of .tw-hero-photo,
 * both wrapped in .tw-hero-media — NOT children of .tw-hero-photo itself.
 * .tw-hero-photo keeps overflow:hidden (for its own rounded corners), which
 * would clip the dashboard card since it deliberately overhangs the edge.
 *
 * <div className="tw-hero-media">
 *   <div className="tw-hero-photo" style={{ backgroundImage: "url(...)" }} />
 *   <HeroStats />
 *   <HeroDashboard />
 * </div>
 *
 * Uses only classes already defined in terraweb.css
 * (.tw-stat-card, .tw-dash-card, .tw-dash-mini, plus the
 * .tw-hero-media / .tw-hero-stats / .tw-hero-dash / .tw-dash-* additions).
 */

export function HeroStats() {
  return (
    <div className="tw-hero-stats">
      <div className="tw-stat-card">
        <div className="tw-stat-label">Today's Collection</div>
        <div className="tw-stat-num">12,650 Ltrs</div>
        <div className="tw-stat-delta">↑ 12.5% vs yesterday</div>
      </div>

      <div className="tw-stat-card">
        <div className="tw-stat-label">Active Farmers</div>
        <div className="tw-stat-num">2,458</div>
        <div className="tw-stat-delta">↑ 6.4% this month</div>
      </div>

      <div className="tw-stat-card">
        <div className="tw-stat-label">Collection Centres</div>
        <div className="tw-stat-num">32</div>
        <div className="tw-stat-delta">All centres active</div>
      </div>
    </div>
  );
}

export function HeroDashboard() {
  const metrics = [
    { label: "Total Farmers", value: "2,458", change: "↑ 12% this month" },
    { label: "Milk Collection (L)", value: "125,680", change: "↑ 15.3% this month" },
    { label: "Coffee Collection (Kg)", value: "48,420", change: "↑ 10.6% this month" },
    { label: "Active Centres", value: "32", change: "↑ 3 this month" },
  ];

  const trendPoints = "0,40 20,32 40,36 60,20 80,28 100,10 120,18 140,4";

  const donutSegments = [
    { name: "Kangema", value: 35, color: "var(--tw-orange)" },
    { name: "Kiharu", value: 25, color: "var(--tw-green)" },
    { name: "Murang'a", value: 22, color: "var(--tw-blue)" },
    { name: "Maragua", value: 18, color: "var(--tw-gold)" },
  ];

  return (
    <div className="tw-hero-dash">
      <div className="tw-dash-card h-20-l">
        <div className="tw-dash-title">Dashboard</div>

        <div className="tw-dash-grid">
          {metrics.map((m) => (
            <div className="tw-dash-mini" key={m.label}>
              <div className="tw-dash-mini-label">{m.label}</div>
              <div className="tw-dash-mini-num">{m.value}</div>
              <div className="tw-dash-mini-delta">{m.change}</div>
            </div>
          ))}
        </div>

        <div className="tw-dash-charts">
          <div>
            <div className="tw-dash-chart-title">Milk Collection Trend (Litres)</div>
            <svg viewBox="0 0 140 44" className="tw-dash-trend">
              <polyline
                points={trendPoints}
                fill="none"
                stroke="var(--tw-green)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="tw-dash-xaxis">
              <span>07 May</span>
              <span>15 May</span>
              <span>22 May</span>
              <span>31 May</span>
            </div>
          </div>

          <div>
            <div className="tw-dash-chart-title">Collection by Centre</div>
            <div className="tw-dash-donut-row">
              <DonutChart segments={donutSegments} />
              <ul className="tw-dash-legend">
                {donutSegments.map((s) => (
                  <li key={s.name}>
                    <span
                      className="tw-dash-legend-dot"
                      style={{ backgroundColor: s.color }}
                    />
                    {s.name} {s.value}%
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function DonutChart({ segments }) {
  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  let offsetAccum = 0;

  return (
    <svg width="56" height="56" viewBox="0 0 40 40">
      {segments.map((s) => {
        const dash = (s.value / 100) * circumference;
        const el = (
          <circle
            key={s.name}
            cx="20"
            cy="20"
            r={radius}
            fill="none"
            stroke={s.color}
            strokeWidth="6"
            strokeDasharray={`${dash} ${circumference - dash}`}
            strokeDashoffset={-offsetAccum}
            transform="rotate(-90 20 20)"
          />
        );
        offsetAccum += dash;
        return el;
      })}
    </svg>
  );
}